if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// ─── NEW: HIDE UNAVAILABLE SIZES & AUTO-SELECT ───────────────────────────────
;(function() {
  const variants       = window.productVariants;
  const formatRadios   = [...document.querySelectorAll('input[name^="Format"]')];
  const sizeRadios     = [...document.querySelectorAll('input[name^="Size"]')];
  const variantSelects = document.querySelector('variant-selects');

  function refreshSizes() {
    console.log('=== refreshSizes called ===');
    
    // Re-query DOM elements to get fresh references
    const currentFormatRadios = [...document.querySelectorAll('input[name^="Format"]')];
    const currentSizeRadios = [...document.querySelectorAll('input[name^="Size"]')];
    
    // find the currently-checked Format
    const fmt = currentFormatRadios.find(r => r.checked)?.value;
    console.log('Current format:', fmt);
    if (!fmt) return;

    // compute which Sizes are both tied to that Format AND available
    const allowed = variants
      .filter(v => v.option1 === fmt && v.available)
      .map(v => v.option2);

    console.log('Allowed sizes for format', fmt, ':', allowed);

    currentSizeRadios.forEach(radio => {
      if (allowed.includes(radio.value)) {
        radio.classList.remove('disabled');
        radio.disabled = false;
      } else {
        radio.classList.add('disabled');
        radio.disabled = true;
        radio.checked = false;
      }
    });

    // Check if any size is currently selected and valid for this format
    const currentlySelected = currentSizeRadios.find(r => r.checked && !r.disabled);
    console.log('Currently selected valid size:', currentlySelected?.value || 'none');
    
    // Auto-select first available size only if no valid size is currently selected
    if (!currentlySelected && allowed.length > 0) {
      const firstAvailable = currentSizeRadios.find(r => !r.classList.contains('disabled'));
      console.log('firstAvailable: ', firstAvailable?.value);
      if (firstAvailable) {
        console.log('Auto-selecting first available size:', firstAvailable.value);
        firstAvailable.checked = true;
        // Trigger a change event to notify Shopify's variant selection system
        firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    console.log('=== refreshSizes complete ===');
  }

  // run on initial page load
  console.log('Initial page load - calling refreshSizes');
  refreshSizes();

  // Use event delegation on document to catch all variant changes
  document.addEventListener('change', (e) => {
    // Check if the changed element is a format or size radio
    if (e.target.name && (e.target.name.startsWith('Format') || e.target.name.startsWith('Size'))) {
      console.log('Document change event caught:', e.target.name, e.target.value);
      setTimeout(() => {
        refreshSizes();
      }, 10);
    }
  });

  // Also listen on the product form specifically
  const productForm = document.querySelector('[id*="product-form"]');
  if (productForm) {
    productForm.addEventListener('change', (e) => {
      if (e.target.name && (e.target.name.startsWith('Format') || e.target.name.startsWith('Size'))) {
        console.log('Product form change event:', e.target.name, e.target.value);
        setTimeout(() => {
          refreshSizes();
        }, 10);
      }
    });
  }

  // Optional: also listen for Shopify's 'section:load' event, which fires when sections are re-rendered via AJAX
  document.addEventListener('shopify:section:load', () => {
    console.log('Section load event - calling refreshSizes');
    refreshSizes();
  });

})();